/*global window, document, dataLayer, jQuery, localStorage, theme*/
var imagePath = 'https://yakima-production.s3.amazonaws.com/fmc/';
var rootPath = window.location.href;
var yakimaApiUrl = 'https://api-au.yakima.com/api';
var roofTypeIds = [];
var roofTypeNames = [];
var currentSku = '';
var pageLoaded = false;
var fitId = localStorage.getItem('fitId');
var market = 'au';


var _dcq = _dcq || [];
var _dcs = _dcs || {};
_dcs.account = '3994549';

(function () {
    var dc = document.createElement('script');
    dc.type = 'text/javascript';
    dc.async = true;
    dc.src = '//tag.getdrip.com/3994549.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(dc, s);
})();

dataLayer = [{
    'pageCategory': 'FitMyCar'
}];


if (window.location.href.indexOf('localhost') >= 0) {
    yakimaApiUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/')) + '/api';
}

if (rootPath.indexOf('www.yakima.com') >= 0) {
    rootPath = 'https://www.yakima.com';
} else if (rootPath.indexOf('uat') >= 0) {
    yakimaApiUrl = 'https://gost.yakima.com/api/';
}

if (window.location.href.indexOf('nz.yakima.com') >= 0 || window.location.href.indexOf('yakima.co.nz') >= 0) market = 'nz';




jQuery(document).ready(function ($) {
    'use strict';
  jQuery('html').addClass('market' + market);
      

    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();
        e.preventDefault();
    });

    if (window.location.href.indexOf('modal=1') > 0) {
        fmcModalInit();
    }

    if (jQuery('body').hasClass('catalog-product-view') || jQuery('body').hasClass('template-product')) {
        currentSku = jQuery('.sku').first().text().replace('SKU: #', '');


        if (currentSku.length > 0) {
            fitCheck();

            jQuery('.product-options .cs-select').bind("change", function (e) {
                currentSku = jQuery('.sku').first().text().replace('SKU: #', '');
                if (rootPath.indexOf('jetstream') >= 0 && jQuery(this).closest('dd.last').length() == 0) {
                    console.log('Here we go');
                }
                fitCheck();
            });

        }
    }
    if (jQuery('body').hasClass('template-collection')) {
      console.log('template collection');
      setTimeout(function() {
        categoryPage();
        }, 2500);
    }
    if (window.location.href.indexOf('/windshield') > 0) {
        windshieldPage();
    }
 
    cartPopup();
    setFMCVehicle();
    
 if (window.location.href.indexOf('/pages/fit-my-car') > 0) {
        fmcPage();
    }
  if (window.location.href.indexOf('/pages/fit-detail') > 0) {
        fmcDetailPage();
    }

  
    pageLoaded = true;
});



window.addEventListener('searchspring.yakima.domReady',  e =>  categoryPage());


function getTellUs() {
  var txt = "<h3>Tell us about your vehicle.</h3><p>Please Enter Your Vehicle Year, Make and Model<br/>That way we can give you the best fit for your vehicle. </p>";
  return txt;
}
function getStep2() {
  var txt = "<h3>What does your vehicle roof look like?</h3><p>The roof of the vehicle determines the roof rack.</p>";
  return txt;
}
function getStep3() {
  var txt = "<h3>What kind of crossbars does you roof rack have?</h3><p>Please complete the section to move on to the next step.</p>";
    return txt;
}
function getStep4() {
  var txt = "<h3 class='center vcenter'>Great! Let\'s roll.</h3><p class='center'>Now you can search for products that fit to your vehicle type. Click Save below to begin your search.</p>";
 return txt;
}

function getWhatSystem() {
  var txt = "What rack system?";
 
  return txt;
}
function getSave() {
  var txt = "Save";
  return txt;
}
function getRoofRacksFor() {
  var txt = "Roof Racks For";
  return txt;
}
function getThirdParty() {
  var txt = "<h3>Third Party or Custom Rack</h3><p>A system made by one of our competitors</p>";
  return txt;
}


function getAddVehicle() {
  var txt = " <span id='label-find'>Find the right racks for your vehicle</span><span class='get-started-button yakima-fmc right-arrow-link'> </span>";
  return txt;
}
function getRoofType(roofType) {
  var txt = roofType;
  return txt;
}

function getYear() {
  var txt = "Year";
  return txt;
}
function getMake() {
  var txt = "Make";
  return txt;
}
function getModel() {
  var txt = "Model";
  return txt;
}
function getType() {
  var txt = "Type";
  return txt;
}
function getRemove() {
  var txt = "Remove";
  return txt;
}
function fmcModalInit() {
    jQuery('#fmc-modalbackground').show();
    jQuery('#fmc-container').show();
    jQuery('.white-header').css('height', 0);
    jQuery('#fmc-container').html('<div id="fmc-header"><span class="fmc-title">' + getAddVehicle() + '</span><span class="close">X CLOSE</span></div><div id="fmc-step1" class="third"><div class="content"></div></div><div id="fmc-step2" class="third"><div class="content"></div></div><div id="fmc-step3" class="third"><div class="content"></div></div>');

    jQuery('#fmc-step1').append('<div class="fmc-modal-vehicle"><span class="name"></span><a href="">Edit</a><hr/></div>');
    jQuery('#fmc-step1 .content').html(getTellUs() + '<select id="year-selector"></select><select id="make-selector"></select><select id="model-selector"></select>');

    jQuery('#fmc-step2').append('<div class="fmc-modal-vehicle"><span class="name"></span><a href="">Edit</a><hr/></div>');
    resetSteps();

    loadYears();
    jQuery('#fmc-container .close').click(function () {
        jQuery('#fmc-container').hide();
        jQuery('#fmc-modalbackground').hide();
        jQuery('.white-header').css('height', 'auto');


    });
    jQuery('.fmc-modal-vehicle a').bind("click tap", function (e) {
        jQuery(this).parent().parent().removeClass('selected');
        e.preventDefault();
    });
}
function clearLocalStorage() {
  
  var partnerId = localStorage.getItem('partnerId');
  var ipCountry = localStorage.getItem('ipCountry');
  var subscribeSeen = localStorage.getItem('subscribe-seen');
  var klaviyo = localStorage.getItem('klaviyoOnsite');
  localStorage.clear();
  if (partnerId)
    localStorage.setItem('partnerId', partnerId);
  if (ipCountry)
    localStorage.setItem('ipCountry', ipCountry);
  if (subscribeSeen)
    localStorage.setItem('subscribe-seen', subscribeSeen);
   if (klaviyo)
    localStorage.setItem('klaviyoOnsite', klaviyo);
}
function resetSteps() {
    jQuery('#fmc-step2 .content').addClass('blur').html(getStep2() + '<div class="option crossbars"><img src="https://yakima-production.s3.amazonaws.com/fmc/car-hasrack.jpg"><h3>My vehicle has crossbars</h3><p>Crossbars run perpendicular to the roof.</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/naked-roof.jpg"><h3>My vehicle roof is \'naked\'</h3><p>There is nothing on the roof at all.</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/flush-siderails.jpg"><h3>My Vehicle roof has Flush Side Rails.</h3><p>Flush side rails run parrallel to the doors and are flush to the roof surface.</p></div>');
    jQuery('#fmc-step3 .content').addClass('blur').html(getStep3() + '<div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/jetstream.png"><h3>JetStream</h3></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/corebar.png"><h3>CoreBar</h3><p></p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/hdbar.png"><h3>HDBar</h3><p>﻿</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/roundbar.png"><h3>RoundBar</h3><p></p></div>');

}
function loadYears() {
    jQuery('#year-selector').html(jQuery('<option></option>').attr('value', '').text(getYear()));
    jQuery('#model-selector').addClass('disabled').append(jQuery('<option></option>').attr('value', '').text(getModel()));
    jQuery('#make-selector').addClass('disabled').append(jQuery('<option></option>').attr('value', '').text(getMake()));
    for (year = new Date().getFullYear() + 1; year >= new Date().getFullYear() - 39; year--) {
        $option = jQuery('<option></option>').attr('value', year).text(year);
        jQuery('#year-selector').append($option);
    }
    if (localStorage.getItem('year')) {
        jQuery('#year-selector').val(localStorage.getItem('year'));
        yearSelected(jQuery('#year-selector'));
        jQuery('#make-selector').show().removeClass('disabled');
    }
    jQuery('#year-selector').change(function () {
        jQuery('#make-selector').show().removeClass('disabled');
        jQuery('#fmc-step2').removeClass('selected');
        year = jQuery('#year-selector').val();
       clearLocalStorage();
        resetSteps();
        localStorage.setItem('year', year);
        yearSelected();
        jQuery('#model-selector').html(jQuery('<option></option>').attr('value', '').text(getModel()));

    });
}
function yearSelected(el) {
    year = jQuery('#year-selector').val();

    if (!year) {
        return;
    }
    jQuery('#make-selector').html(jQuery('<option></option>').attr('value', '').text(getMake()));
    url = yakimaApiUrl + '/make/GetMakes/' + year + '/true/true/3/' + market;
  console.log(url);
    jQuery.get(url, function (data) {
        if (typeof data == 'object') {
            jQuery('#model-selector').removeClass('disabled');
            jQuery.each(data, function (i, e) {
                var selected = false;
                if (localStorage.getItem('makeId') && e.value == localStorage.getItem('makeId'))
                    selected = true;
                if (typeof e.id !== 'undefined' && typeof e.name !== 'undefined') {
                    $option = jQuery('<option></option>').attr('value', e.id).text(e.name);
                    jQuery('#make-selector').append($option);
                }
            });
        }
        if (localStorage.getItem('makeId')) {
            jQuery('#make-selector').val(localStorage.getItem('makeId'));
            makeSelected(jQuery('#make-selector'));
        //    jQuery('#make-selector').removeClass('disabled');
        }
        jQuery('#make-selector').unbind().change(function () {
            jQuery('#model-selector').show().removeClass('disabled');
            jQuery('#fmc-step2').removeClass('selected');

            year = jQuery('#year-selector').val();
            makeId = jQuery('#make-selector').val();
            makeName = jQuery('#make-selector option:selected').text();
            clearLocalStorage();
            resetSteps();
            localStorage.setItem('year', year);
            localStorage.setItem('makeId', makeId);
            localStorage.setItem('make-name', makeName);
            makeSelected();

        });
    });

}

function makeSelected() {
    makeId = jQuery('#make-selector').val();
    if (!year || !makeId) {
        return;
    }
    url = yakimaApiUrl + '/model/GetUniqueModels/' + year + '/' + makeId + '/true/true/3/' + market;

console.log(url);
    jQuery.get(url, function (data) {
        jQuery('#model-selector').html('');
        if (typeof data == 'object') {
            jQuery('#model-selector').append(jQuery('<option></option>').attr('value', '').text(getModel()));
            jQuery('#make-selector').removeClass('disabled');
            jQuery.each(data, function (i, e) {
                if (typeof e.name !== 'undefined')
                    jQuery('#model-selector').append(jQuery('<option></option>').attr('value', e.id).text(e.name));
            });
        }

        if (localStorage.getItem('vehicleMarketId')) {
            jQuery('#model-selector').val(localStorage.getItem('vehicleMarketId'));
            if(jQuery('#model-selector').val())
                modelSelected();
        }
        jQuery('#model-selector').unbind().change(function () {
            if (jQuery('#model-selector option:selected').text() != localStorage.getItem('model-name')) {
                jQuery('#fmc-step2').removeClass('selected');

                year = jQuery('#year-selector').val();
                makeId = jQuery('#make-selector').val();
                makeName = jQuery('#make-selector option:selected').text();
                clearLocalStorage();
                resetSteps();
                localStorage.setItem('year', year);
                localStorage.setItem('makeId', makeId);
                localStorage.setItem('make-name', makeName);
                localStorage.setItem('vehicleMarketId', jQuery('#model-selector').val());
                localStorage.setItem('model-name', jQuery('#model-selector option:selected').text());
                modelSelected();

            }
        });
    });
}

function modelSelected() {
    var model = jQuery('#model-selector option:selected').text();
    var vmId = jQuery('#model-selector').val();
  
    model = model.replaceAll('/', '~');
    if (!year || !makeId) {
        return;
    }
    localStorage.setItem('vehicleMarketId', vmId);
    selectVehicle();
    
}
function selectVehicle() {
    var modelName = jQuery('#model-selector option:selected').text();
    var vmId = jQuery('#model-selector').val();

    localStorage.setItem('model-name', modelName);
    if (modelName.length > 0) {
        jQuery('#fmc-step1 .fmc-modal-vehicle .name').text(localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name'));

    }

    modelName = modelName.replaceAll('/', '~');
    jQuery('#fmc-step2 .content').removeClass('top-selected');
    //var url = yakimaApiUrl + '/vehicle/GetVehicleByModel/' + localStorage.getItem('year') + '/' + localStorage.getItem('makeId') + '/' + encodeURIComponent(modelName)  + '/0/3';
    var url = yakimaApiUrl + '/vehicle/GetVehicleByVM/' + vmId;
  console.log(url);
    jQuery.get(url, function (data) {
        if (typeof data == 'object') {
            localStorage.setItem("isTruck", data[0].class == 2);
           
                localStorage.setItem("vehicleId", data[0].id);
                loadRoofTypes();
                jQuery('#fmc-step1').addClass('selected');
        }
    });
}

function selectSystem() {

    if (!jQuery('#select-system').hasClass('disabled')) {
        var rooftypeId = localStorage.getItem('rooftypeId');
        var rooftypeStatus = localStorage.getItem('rooftypeStatus');
        var systemPage = jQuery('#shopify-section-system-template').length > 0;
        var productPage = jQuery('body.catalog-product-view').length > 0;
        var towerCat = window.location.href.indexOf('product-type/tower-system') > 0;
        var isTruck = localStorage.getItem('isTruck') ;
        var container = '<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content">';
        var urlprefix = '';

        if(window.location.href.indexOf('/fr/') > 0)
          urlprefix = '/fr';
      
        dataLayer.push({
            'event': 'cftProgress',
            'step': {
                'name': 'Car Fit Tool - Selected',
                'vpv': '/vpv/car-fit-tool/selected'
            },
            'vehicleData': {
                'make': '' + localStorage.getItem('make-name') + '',
                'model': '' + localStorage.getItem('model-name') + '',
                'year': '' + localStorage.getItem('year') + '',
                'roofType': '' + localStorage.getItem('rooftypeName').replace('My vehicle has ', '') + '',
                'system': '' + localStorage.getItem('system-name') + ''
            }
        });
        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
        if (localStorage.getItem('vehicle-type'))
            vehName = vehName + ' ' + localStorage.getItem('vehicle-type');
        var roofType = localStorage.getItem('rooftypeName').replace('My vehicle has ', '').replace('I have a ', '').replace('I have ', '');
        if (roofType == 'crossbars') {
            if (localStorage.getItem('system-name') == 'BaseLine' || localStorage.getItem('system-name') == 'QTower' || localStorage.getItem('system-name') == '1A Raingutter' || localStorage.getItem('system-name') == 'Control Tower') {
                roofType = 'naked roof';
                rooftypeId = '1';
            }
            else if (localStorage.getItem('system-name') == 'SkyLine' || localStorage.getItem('system-name') == 'Yakima FlushBar' || localStorage.getItem('system-name') == 'RidgeLine') {
                roofType = 'flush siderails';
                rooftypeId = '12';
            }
            else if (localStorage.getItem('system-name') == 'TimberLine' || localStorage.getItem('system-name') == 'Yakima RailBar' || localStorage.getItem('system-name') == 'RailGrab') {
                roofType = 'raised siderails';
                rooftypeId = '4';
            }

        }

        dataLayer.push({
            'event': 'fmcSelect',
            'fmcVehicle': '' + vehName,
            'fmcRooftype': '' + roofType + '',
            'fmcRooftypeId': '' + rooftypeId + '',
            'fmcVehicleId': '' + localStorage.getItem('vehicleId')
        });

        if (localStorage.getItem('fitId') && parseInt(localStorage.getItem('fitId')) > 0) {
            dataLayer.push({
                'event': 'fmcFitSelect',
                'action': 'existing',
                'fmcFitId': '' + localStorage.getItem('fitId')
            });
          if (window.location.href.indexOf('retailer-fmc') > 0 || window.location.href.indexOf('configurator') > 0) {
            window.location = urlprefix + '/collections/all';
        	}
        }
        console.log('make:' + localStorage.getItem('make-name') + '|model:' + localStorage.getItem('model-name') + '|year:' + localStorage.getItem('year') + '|roofType:' + localStorage.getItem('rooftypeName').replace('My vehicle has ', '') + '|system:' + localStorage.getItem('system-name') + '');

      
        if (rooftypeStatus == '5' && isTruck != 'true')
            jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your vehicle. </p><div class="actions"><a class="button reversed outline" href="/pages/custom-solutions-roof-racks-yakima">Custom Install Options</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');
        else if ((localStorage.getItem('noRoofFit') == 'true' || rooftypeStatus == '-1') && isTruck != 'true')
            jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your vehicle. </p><div class="actions"><a class="button reversed outline" href="/pages/custom-solutions-roof-racks-yakima">Custom Install Options</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');
        else if (fitId == -4)
            jQuery('body').first().append(container + '<p><b>For Your Safety we cannot confirm compatibility with non-Yakima Roof Rack Systems.</b><br/>However, you\'re more than welcome to shop and purchase any Yakima products with this in mind.  Our products do fit nearly any crossbar shape - but again, we cannot confirm compatibility and fullfill product and gear warranty with a non-Yakima rack system.</p><div class="actions"><a onclick="reloadPage();" class="button reversed close">I Understand</a></div></div></div>');
        else if (isTruck == 'true' && localStorage.getItem('truckbedId') == '-2')
            jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your truckcap.</p><div class="actions"><a class="button reversed outline" href="/pages/custom-solutions-roof-racks-yakima">Custom Install Options</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');

        else if (fitId == -2 )
            window.location =  urlprefix + '/pages/fit-my-car';
         else if ((fitId == 0 || fitId == -3) && !systemPage && !towerCat && !productPage) {
           window.location =  urlprefix + '/pages/fit-my-car';
                      
        }
        else if (window.location.href.indexOf('retailer-fmc') > 0 || window.location.href.indexOf('configurator') > 0) {
            window.location = urlprefix + '/collections/all';
        }
        else {
         //   setCurrentFit();
            if (window.location.href.indexOf('stayput') <= 0) {
                if (window.location.href.indexOf('modal') > 0)
                    window.location = window.location.href.replace('?modal=1', '');
                else
                        window.location.reload();

            }
        }
        jQuery('#fmc-container').hide();
        jQuery('#fmc-modalbackground').hide();
        jQuery('.white-header').css('height', 'auto');



    }
}

function reloadPage() {

    if (window.location.href.indexOf('modal') > 0)
        window.location = window.location.href.replace('?modal=1', '');
    else
        window.location.reload();
}
function closeFMCModal() {
    jQuery('#fmc-modal-container').remove();

}
function checkInventory(sku) {
    if (sku && sku.length > 0) {
        var url = yakimaApiUrl + '/inventory/GetInventoryValue?sku=' + sku;
        console.log(url);
        jQuery.get(url, function (data) {
            return parseInt(data);


        });
    }
}
function loadRoofTypes() {
    jQuery('#fmc-step2 .content').removeClass('blur');
    var vmId = jQuery('#model-selector').val();

    if (localStorage.getItem('isTruck') == 'true') {
        jQuery('#fmc-step2').addClass('scroll');
        jQuery('#fmc-step2 .content').empty().append('<h3>1) What does your vehicle roof look like?</h3><a href="" class="edit-crossbars">Edit</a>');
    }
    else {
        jQuery('#fmc-step2').removeClass('scroll');
        jQuery('#fmc-step2 .content').empty().append(getStep2());
    }
  var model = localStorage.getItem('model-name');
  model = model.replaceAll('/', '~');
    jQuery('#fmc-step2 .content').append('<div class="option toc crossbars" data-id="0"><img src="' + imagePath + 'car-hasrack.jpg"/><h3>' + getRoofType('My vehicle has crossbars') + '</h3></div>');
    url = yakimaApiUrl + '/rooftype/GetRoofTypesByVM/' + vmId + '/false/true';
    console.log(url);
    roofTypeIds = [];
    roofTypeNames = [];

    jQuery.get(url, function (data) {
        if (typeof data == 'object') {
            var cnt = 0;
            jQuery.each(data, function (i, e) {
                if (typeof e.id !== 'undefined') {
                    var cls = '';
                  //  if (e.Id == 14 && jQuery('#fmc-step2 .content .option.naked-roof').length > 0) {
                        //Hide Naked Roof Fixed Point if Naked Roof exists
                 //   }
                //    else
                        jQuery('#fmc-step2 .content').append('<div class="option toc ' + e.img + cls + '" data-id="' + e.id + '" data-status="' + e.statusId + '"><img src="' + imagePath + e.img + '.jpg"/><h3>' + getRoofType(e.name) + '</h3></div>');
                    roofTypeIds[cnt] = e.id;
                    roofTypeNames[cnt] = e.name;
                    cnt++;
                }
            });
            localStorage.setItem('noRoofFit', cnt == 0);
            if (cnt == 0) {
                jQuery('#fmc-step2 .content').append('<div class="option toc naked-roof" data-id="1"><img src="' + imagePath + 'naked-roof.jpg"/><h3>' + getRoofType('Naked Roof') + '</h3></div>');

            }


            jQuery('#fmc-step2 .content .option.toc').click(function () {
                jQuery('#fmc-step2 .content .option.toc.selected').removeClass('selected');
                jQuery(this).addClass('selected');
                localStorage.setItem('rooftypeId', jQuery(this).attr('data-id'));
                localStorage.setItem('rooftypeName', jQuery(this).find('h3').text());
                localStorage.setItem('rooftypeStatus', jQuery(this).attr('data-status'));

                if (localStorage.getItem('isTruck') !== 'true' || jQuery('#fmc-step2 .content .option.truck.selected').length > 0) {
                    loadTowers();
                    jQuery('#fmc-step2').addClass('selected');
                }
                jQuery('#fmc-step2 .name').text(jQuery(this).find('h3').text());
                jQuery('.truckOptions').removeClass('blur');

            });
            jQuery('#fmc-step2 .content .option').each(function () {
                if (localStorage.getItem('fitId') && localStorage.getItem('fitId') != '0' && jQuery(this).attr('data-id') == '0')
                    jQuery(this).click();
                else if (localStorage.getItem('fitId') == '0' && parseInt(localStorage.getItem('rooftypeId')) == jQuery(this).attr('data-id')) {
                    jQuery(this).click();
                }
            });
            jQuery('#fmc-step2 .content .edit-crossbars').bind("click tap", function (e) {
                jQuery('#fmc-step2 .content').removeClass('top-selected');
                e.preventDefault();
            });
            if (localStorage.getItem('isTruck') == 'true') {
                var cls = ' blur';
                if (jQuery('.option.toc.selected').length > 0)
                    cls = '';
                jQuery('#fmc-step2 .content').append('<hr/>');
                jQuery('#fmc-step2 .content').append('<span class="truckOptions' + cls +'"><h3>2) What does your ute tub look like?</h3></span>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck empty" data-id="-1"><img src="' + imagePath + 'truck-norack.jpg"/><h3>' + getRoofType('My ute bed is empty') + '</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck crossbars" data-id="16"><img src="' + imagePath + 'truck-hasrack.jpg"/><h3>' + getRoofType('I have crossbars across my empty ute bed') + '</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck truckcap" data-id="-2"><img src="' + imagePath + 'truck-shell.jpg"/><h3>Canopy</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck truckcap-bars" data-id="4"><img src="' + imagePath + 'truck-shell-crossbars.jpg"/><h3>Canopy with roof rack</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck tonneau" data-id="-3"><img src="' + imagePath + 'tonneau.jpg"/><h3>Tonneau cover</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck tonneau tonneau-bars" data-id="16"><img src="' + imagePath + 'tonneau-crossbars.jpg"/><h3>Tonneau cover with crossbars</h3></div>');
                jQuery('#fmc-step2 .content .select-roof').click(function () {
                    localStorage.setItem('rooftypeId', '0');
                    loadTowers();
                });
                jQuery('#fmc-step2 .content .option.truck').unbind().click(function () {
                    jQuery('#fmc-step2 .content .option.truck.selected').removeClass('selected');
                    jQuery(this).addClass('selected');
                    localStorage.setItem('truckbedId', jQuery(this).attr('data-id'));
                    localStorage.setItem('hasTonneau', jQuery(this).hasClass('tonneau'));
                    if (jQuery('#fmc-step2 .content .option.toc.selected').length > 0) {
                        jQuery('#fmc-step2').addClass('selected');
                        loadTowers();
                    }
                });
            }
        }
    });


}


function loadTowers() {


    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var isTruck = localStorage.getItem('isTruck');


    jQuery('#fmc-step3 .content').removeClass('blur');

    if ((rooftypeId != '0' && isTruck != 'true') || (isTruck && (localStorage.getItem('rooftypeId') == '1' || localStorage.getItem('rooftypeId') == '3' || localStorage.getItem('rooftypeId') == '4' || localStorage.getItem('rooftypeId') == '12')  && (localStorage.getItem('truckbedId') == '-1' || localStorage.getItem('truckbedId') == '-2' || localStorage.getItem('truckbedId') == '-3'))) {
        jQuery('#fmc-step3').removeClass('scroll');
        jQuery('#fmc-step3 .content').empty().append(getStep4());
        jQuery('#fmc-step3 .fmc-save').remove();
        jQuery('#fmc-step3 .content').append('<div class="fmc-save"><button onclick="selectSystem()" id="select-system">' + getSave() + '</button></div>');

        if (localStorage.getItem('truckbedId') == '-2' || localStorage.getItem('truckbedId') == '-3')
            fitId = -3;
        else
            fitId = 0;
        localStorage.setItem('fitId', fitId);
        localStorage.setItem('system-name','');
        localStorage.setItem('crossbarMin','');

    }
    else {

        jQuery('#fmc-step3 .content').empty().append('<h3>' + getWhatSystem() + '</h3>');

       // if (isTruck == 'true' && localStorage.getItem('rooftypeId') != '0')
       //     rooftypeId = '16';
        if(localStorage.getItem('truckbedId') == '4')
            rooftypeId = '4';

        var url = yakimaApiUrl + '/fit/getFits/AU/' + vehicleId + '/' + rooftypeId + '/true/false/false';

    //    if (isTruck == 'true' && localStorage.getItem('truckbedId') == '16')
      //      url = url + '&includeTruck=true';
     //   if (isTruck == 'true' && localStorage.getItem('truckbedId') == '-1')
         //   url = url + '&excludeRoofType=16';

        var container = "";

        if (isTruck == 'true') {
            jQuery('#fmc-step3 .content').append('<select id="rooftype-selector"><option value="0">Select Mount Location</option></select>');
            jQuery('#fmc-step3 .content select').append('<option value="1">Roof</option>');
            jQuery('#fmc-step3 .content select').append('<option value="16">Truck Bed</option>');
        }
        else if (rooftypeId == 0 && roofTypeIds.length > 1) {
            jQuery('#fmc-step3 .content').append('<select id="rooftype-selector"><option value="0">Showing All</option></select>');
            for (i = 0; i < roofTypeIds.length; i++) {
                jQuery('#fmc-step3 .content select').append('<option value="' + roofTypeIds[i] + '">' + roofTypeNames[i] + '</option>');
            }

        }
        else {
            jQuery('#fmc-step3 .content').append('<div class="select-spacer"></div>');
        }
        jQuery('#fmc-step3 #rooftype-selector').change(function () {
            var rtId = jQuery('#fmc-step3 #rooftype-selector').val();
            jQuery('#fmc-step3 .content .option').show();
            jQuery('#fmc-step3 .content .option').each(function (index) {
                if (rtId != '0' && jQuery(this).attr('data-rooftype') != rtId && jQuery(this).attr('data-rooftype') != -1) {
                    jQuery(this).hide();
                }
            });
        });
      console.log(url);
        jQuery.get(url, function (data) {
            if (typeof data == 'object') {
                var cnt = 0;
                jQuery.each(data, function (i, e) {
                    if (typeof e.id !== 'undefined') {
                        var cls = '';
                        if (fitId == e.id) {
                            cls = ' selected';
                            jQuery('#select-system').removeClass('disabled');
                        }
                        if (localStorage.getItem('hasTonneau') == 'true' && (e.name.toLowerCase().indexOf('outdoorsman') >= 0 || e.name.toLowerCase().indexOf('bedrock') >= 0)) {
                            //Hide Outdoorsman and BedRock if vehicle has Tonneau cover
                        }
                        else {
                            jQuery('#fmc-step3 .content' + container).append('<div class="option' + cls + '" data-id="' + e.id + '" data-rooftype="' + e.roofTypeId + '" data-minlength="' + e.minBarLength + '" data-status="' + e.statusId + '"><img src="' + imagePath + e.name.toLowerCase().replace('yakima ', '').replace(' ', '-') + '.png"/><h3>' + e.name + ' System</h3><p>' + e.shortDesc + '</p></div>');
                            localStorage.removeItem('noRoofFit');
                        }
                    }
                });


                jQuery('#fmc-step3 .content').append('<div class="option thirdparty" data-id="-4" data-rooftype="-1"><img src="' + imagePath + 'third-party.jpg"/>' + getThirdParty() + '</div>');

                if (jQuery('#fmc-step3 .fmc-save').length == 0)
                    jQuery('#fmc-step3').append('<div class="fmc-save"><button onclick="selectSystem()" id="select-system" class="disabled">Save</button></div>');
                else
                    jQuery('#select-system').removeClass('disabled').addClass('disabled');

                if (jQuery('#fmc-step3 .content .option').length > 4)
                    jQuery('#fmc-step3').addClass('scroll');
                else
                    jQuery('#fmc-step3').removeClass('scroll');

                jQuery('#fmc-step3 .content .option').click(function () {
                    fitId = jQuery(this).attr('data-id');
                    localStorage.setItem('fitId', fitId);
                });

                var rtId = jQuery('#fmc-step3 #rooftype-selector').val();


                jQuery('#fmc-step3 .content .option').click(function () {
                    jQuery('#fmc-step3 .content .option.selected').removeClass('selected');
                    jQuery(this).addClass('selected');
                    jQuery('#select-system').removeClass('disabled');
                    localStorage.setItem('fitId', jQuery(this).attr('data-id'));
                //    localStorage.setItem('rooftypeId', jQuery(this).attr('data-rooftype'));
                    var systemName = jQuery('#fmc-step3 .content .option.selected h3').first().text().replace(' System', '');
                    localStorage.setItem('system-name', systemName);
                    localStorage.setItem('crossbarMin', jQuery('#fmc-step3 .content .option.selected').first().attr('data-minlength'));
                });
                jQuery('#fmc-step3 .content .option').each(function () {
                    if (parseInt(localStorage.getItem('fitId')) == jQuery(this).attr('data-id')) {
                        jQuery(this).click();
                    }
                });
            }
        });


    }


}
function setFMCVehicle() {
    if (localStorage.getItem('model-name')) {
        var fmcMsg = '';
        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
        fmcMsg = '<a id="get_started_button"> ' + vehName;
        if (localStorage.getItem('system-name'))
            fmcMsg += ' with a ' + localStorage.getItem('system-name') + ' system';
        fmcMsg += '</a> <a id="vehicle_remove" class="right-arrow-link" onclick="removeVehicle()"> <span>' + getRemove() + '</span></a>';

        jQuery('#fmc-add-vehicle').html(fmcMsg);
        jQuery('#fmc-page #vehicle-title').html(getRoofRacksFor() + ' '+ vehName);

    }
    else {
        jQuery('#fmc-add-vehicle').html('<a id="get_started_button">' + getAddVehicle() + '</a>');
    }
    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();
        e.preventDefault();
    });
}
function removeVehicle() {
    
  clearLocalStorage();
    fitId = 0;
    jQuery('#fmc-add-vehicle').html('<a id="get_started_button">' + getAddVehicle() + '</a>');
    jQuery('#fitCurrentVehicle').html('<p><span style="color: #CCCCCC;">&#149;</span> Is this product compatible with your vehicle?&nbsp;&nbsp; <a href="#" class="fmc">Add Your Vehicle</a></p>');
    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();

        e.preventDefault();
    });
   if (jQuery('body').hasClass('template-collection')) {
        window.location.reload();
    }
    fitCheck();
}

function fitCheck() {
    var productFit = 0;
    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
    var isTent = false;
    var sku = jQuery('.product-single__meta .sku').first().text().replace('SKU: #', '');
    var systemPage = (jQuery('#shopify-section-system-template').length > 0);
    var isLNL = window.location.href.indexOf('locknload') > 0;
    var truckSystem = window.location.href.indexOf('overhaul') > 0 || window.location.href.indexOf('outpost') > 0 || window.location.href.indexOf('bedrock') > 0 || window.location.href.indexOf('outdoorsman') > 0;
    var isMOD = false;

    if (localStorage.getItem('systemId') && systemPage)
        fitId = localStorage.getItem('systemId');
  	if(localStorage.getItem('fitId') == '0' && isLNL && localStorage.getItem('towerSystemId'))
      fitId = localStorage.getItem('towerSystemId');

    if (sku == "8007406" || sku == "8007407" || sku == "8007434" || sku == "8007432" || sku == "8007436" || sku == "8007437")
        isTent = true;

    jQuery('.template-product').addClass('nofit');

   // if ((fitId && fitId.length > 0) || (vehicleId && vehicleId.length > 0 && rooftypeId && rooftypeId.length > 0)) {
        if (!fitId || fitId.length == 0)
            fitId = 0;

        if (truckSystem && localStorage.getItem('truckbedId') == '-4') {
            if (isTent)
                setFitMessage('#666', 'We cannot confirm compatibility with your rack system, please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.');
            else
                setFitMessage('#666', 'We cannot confirm compatibility with your rack system.');
        }
        else if (truckSystem && localStorage.getItem('hasTonneau') == 'true' && ((window.location.href.indexOf('overhaul-hd-system') < 0 && window.location.href.indexOf('overhaul-hd-tonneau') < 0 && window.location.href.indexOf('outpost-hd-system') < 0) || localStorage.getItem('tonneauType') == 'tonneau-0')) {
            setFitMessage('Red', ' Does not fit your ' + vehName + '.');
        }
        else if (truckSystem && fitId == 0 && localStorage.getItem('truckbedId') == '-3') {
            if (isTent)
                setFitMessage('#666', 'Please contact the manufacturer of your Truck Shell/RV/Camper for their recommendation and options for carrying roof top tents, and read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.');
            else
                setFitMessage('#666', 'Please contact the manufacturer of your Truck Shell/RV/Camper for their recommendation and options for carrying Yakima products.</p>');
        }
        else if (truckSystem && localStorage.getItem('isTruck') == 'false') {
            setFitMessage('#666', 'This system is designed for truck beds only.');
        }
        else if (truckSystem && localStorage.getItem('truckbedId') == '-2') {
            productFit = 1;
        }
        else if ((vehicleId == null || vehicleId == 0) && isTent) {
            setFitMessage('#666', 'We need more information before confirming vehicle fit. <a href="#" onclick="fmcModalInit();">Continue</a>.');
        }
        else if (isTent) {
            setFitMessage('#666', 'Please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>. ');

        }
   		else if (localStorage.getItem('fitId') == '-4')
                        setFitMessage('#666', 'We cannot confirm compatibility with your rack system. ');
        else if (localStorage.getItem('system-name') == 'Factory Rack' && isTent) {
            setFitMessage('Red', ' Does not fit your ' + vehName + '.');
        }

        else {
            
    
        }
   // }

}

function setFitMessage(color, content) {
    document.getElementById('fitCurrentVehicle').innerHTML = '<p><span style="color: ' + color + ';">&#149;</span> ' + content + '</p>';

}

function categoryPage() {
    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var towerCat = window.location.href.indexOf('collections/roof-rack-systems') > 0 || window.location.href.indexOf('collections/truck-rack-systems') > 0;


  //setTimeout(function() {
    if (towerCat) {
        var listClass = 'grid grid--view-items';
      jQuery('#category-nofit').remove();
        jQuery('#shopify-section-collection-template .ss-content-container').first().append('<div id="category-nofit"><h2>Does Not Fit Your Vehicle</h2><ul class="' + listClass + '"></ul></div>');
        jQuery('.main .sidebar').hide();
        jQuery('.main .col-main').css('padding-top', '50px');
        jQuery('.toolbar').hide();

    }
  var gridItems = [];
        var cnt = 0;
        
        
  

    
 // }, 2500);
}

function fmcPage() {
    var vmId = localStorage.getItem('vehicleMarketId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var marketId = 3;
  var lang = market;
  
  if(lang == 'nz') marketId = 4;

        var url = yakimaApiUrl + '/system/GetSystems/' + vmId + '/' + rooftypeId + '/' + lang;
    console.log(url);
    

          jQuery('#fmc-page #rack-systems').html('<div id="fit-filters"></div>');
    jQuery.get(url, function (data) {
      console.log(data);
            jQuery.each(data, function (i, e) {
              var system = '';
              const streamline = [32,38,33,43,34,39,41,42];
             
              
                if(e.fitTypeId != 46)
                   system = GetSystemHtml(false, e.fitId, e.fitTypeId, e.mountType, e.fitImage, e.platformSku, e.minBarLength,  e.barSizeFront, e.barSizeRear, e.loadRating, e.barCount, e.components, e.comments);
              //  if(e.fitTypeId == 42) {
               //   system += GetSystemHtml(false, e.fitId, 942, e.mountType, e.fitImage, e.platformSku, e.minBarLength, e.barSizeFront, e.barSizeRear, e.loadRating, e.components, e.comments);
               // }
                if(e.fitTypeId == 45) {
                //  system += GetSystemHtml(945, e.PlatformSku, e.MinBarLength, e.BarSizeFront, e.BarSizeRear, e.LoadRating, e.Components);
                }
               jQuery('#fmc-page #rack-systems').append(system);
            });
           addFilters();
           
    });
    

    
}
function fmcDetailPage() {
  
  var year = localStorage.getItem('year');
    var makeId = localStorage.getItem('makeId');
    var model = localStorage.getItem('model-name');
    var type = localStorage.getItem('vehicle-type');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var vmId = localStorage.getItem('vehicleMarketId');

    model = model.replaceAll('/', '~');
  var lang = market;
        var url = yakimaApiUrl + '/system/GetSystems/' + vmId + '/' + rooftypeId + '/' + lang;
  
    const urlParams = new URLSearchParams(window.location.search);
    var fitId = urlParams.get('fitId');

        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
      jQuery('#fmc-page #vehicle-title').html(vehName);
  
    console.log(url);
    
          jQuery('#fmc-page #rack-systems').html('');
    jQuery.get(url, function (data) {
      console.log(data);
            jQuery.each(data, function (i, e) {
              if(e.fitId == fitId) {
                var system = GetSystemHtml(true, e.fitId, e.fitTypeId, e.mountType, e.fitImage, e.platformSku, e.minBarLength, e.barSizeFront, e.barSizeRear, e.loadRating, e.barCount, e.components, e.comments);
               jQuery('#fmc-page #rack-systems').append(system);
                 var url2 = yakimaApiUrl + '/system/GetSystem/' + fitId + '/3';
                console.log(url2);
                 jQuery.get(url2, function (data2) {
                  if (typeof data2 == 'object') {
                    console.log(data2);
                    if(data2.features != null) {
                       jQuery('#fmc-page #rack-systems').append("<h2>Features</h2>");
                       jQuery('#fmc-page #rack-systems').append(data2.features);
                       jQuery('#fmc-page #rack-systems').append("<br/><br/><h2>Installation</h2>");
                      if(data2.installation != null) {
                       jQuery('#fmc-page #rack-systems').append("<p>" + data2.installation + "</p>");
                      }
                      if(data2.towerSku != null && data2.towerSku.length > 0) {
                       jQuery('#fmc-page #rack-systems').append("<a href='https://assets-au.yakima.com/product/instructions/" + data2.towerSku + "'>" + data2.towerSku + " Instructions</a><br/>");
                      }
                       if(data2.fitKitSku != null && data2.fitKitSku.length > 0) {
                       jQuery('#fmc-page #rack-systems').append("<a href='https://assets-au.yakima.com/product/instructions/" + data2.fitKitSku + "'>" + data2.fitKitSku + " Instructions</a>");
                      }
                      
                       jQuery('#fmc-page #rack-systems').append("<p><br/><a href='https://pit-au.yakima.com?fitid=" + data2.fitId + "'>Installation Settings</a></p>");
                    }
                    if(e.fitTypeId <= 45 || e.fitTypeId == 59) {
                      var installation = GetInstallationMeasurements(data2.m1, data2.m2, data2.m3, data2.m4, data2.p1, data2.p2, data2.fiClip, data2.foClip, data2.riClip, data2.roClip, data2.clipSku, data2.clipSku, data2.rearClipSku, data2.frontClamps, data2.rearClamps, data2.frontPads, data2.rearPads);
                      jQuery('#fmc-page #rack-systems').append(installation);
                    }
                  }
                });
              }
            });
    });
  
     
    
}


function GetInstallationMeasurements(m1, m2, m3, m4, p1, p2, fiClip, foClip, riClip, roClip, clipSku, fclip, rclip, fclamps, rclamps, fpads, rpads) {
  var installation = '';
    installation += '<div id="components"><div class="section"><h2>Installation Measurements</h2>';

    if(m1 != '0') {
        installation += '<div class="left"><div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/m1_icon.png"/></div>';
        installation += '<div class="box-desc"><strong>Front Crossbar</strong><span class="caption">Inner edge of driver’s side leg to inner edge of passenger’s side leg </span></div>';
        installation += '<div class="box-val"><span class=""><strong>' + m1 + ' mm</strong></span></div></div>';
    }
    if(m2 != '0') {
        installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/m2_icon.png"/></div>';
        installation += '<div class="box-desc"><strong>Front Crossbar</strong><span class="caption">Corner of painted or glass roof to leading edge of front pad or foot</span></div>';
        installation += '<div class="box-val"><span class=""><strong>' + m2 + ' mm</strong></span></div></div> </div>';
    }
    installation += '<div class="right">';

    if(m3 != '0') {
        installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/m3_icon.png"/></div>';
        installation += '<div class="box-desc"><strong>Rear Crossbar</strong><span class="caption">Inner edge of driver’s side leg to inner edge of passenger’s side leg</span></div>';
        installation += '<div class="box-val"><strong>' + m3 + ' mm</strong></div></div>';
    }

    if(m4 != '0') {
        installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/m4_icon.png"/> </div>';
        installation += '<div class="box-desc"><strong>Crossbar Spread</strong><span class="caption">Rear edge of front crossbar to rear edge of rear crossbar.</span></div>';
        installation += '<div class="box-val"><strong>' + m4 + ' mm</strong></div></div></div>';
    }

    installation += '<div class="diagram"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/measurements_diagram.png"/>  </div></div>';
            
    if(p1 != '') {
      installation += '<hr/><div class="section"><h2>PITCH SETTINGS</h2>';
      installation += '<div class="left"><div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/p1_icon.png"/></div>';
      installation += '<div class="box-desc"><span class=""><strong>Pitch 1</strong></span><span class="caption">Adjustment on the front legs to help keep the crossbars level</span></div>';
      installation += '<div class="box-val"><span class=""><strong>' + p1 + '</strong></span></div></div> </div>';
      
      installation += '<div class="right"><div class="box-container"><div class="box-logo"><span class="sub2"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/p2_icon.png"/></span></div>';
      installation += '<div class="box-desc"><strong>Pitch 2</strong><span class="caption">Adjustment on the rear legs to help keep the crossbars level</span></div>';
      installation += '<div class="box-val"><strong>' + p2 + '</strong> </div></div></div>';

      installation += '<div class="diagram"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/pitch_diagram.png"/> </div></div>';
    }

    if(fiClip != '') {
        
      if(clipSku.length > 0) {
        var clipNum = clipSku.replace('981360', '').replace('98136', '');

        installation += '<hr/><div class="section"><h2>(SC' + clipNum + ') SIGHT CLIP DETAILS </h2>';
      }
      else
        installation += '<hr/><div class="section"><h2>SIGHT CLIP DETAILS </h2>';

      installation += '<div class="left"><div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Front Inner Clip</strong><span class="caption">Number imprinted on inner clip to be used on front bar</span></div><div class="box-val"><strong>' + fiClip + '</strong></div></div>';

      installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Front Outer Clip</strong><span class="caption">Number imprinted on outer clip to be used on front bar</span></div><div class="box-val"><strong>' + foClip + '</strong></div></div></div>';        


      installation += '<div class="right"><div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Rear Inner Clip</strong><span class="caption">Number imprinted on inner clip to be used on rear bar</span></div><div class="box-val"><strong>' + riClip + '</strong></div></div>';

      installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Rear Outer Clip</strong><span class="caption">Number imprinted on outer clip to be used on rear bar</span></div><div class="box-val"><strong>' + roClip + '</strong></div></div></div>';  
        installation += '<div class="diagram"></div></div>';
    }
    if(fclamps != '') {
        
      if(rclip != '') rclip = fclip;
      installation += '<hr/><div class="section"><h2>BASE CLIP DETAILS </h2>';
      fclip = 'BC' + fclip.replace('98130', '').replace('9813', '');
      rclip = 'BC' + rclip.replace('98130', '').replace('9813', '');

      installation += '<div class="left"><div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/front_productbox_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Front Product</strong><span class="caption">Name of BaseClip product required for front bar</span></div><div class="box-val"><strong>' + fclip + '</strong></div></div>';

      installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/rear_basepadicon.png"></div>';
      installation += '<div class="box-desc"><strong>Front Pad</strong><span class="caption">Number on the pads required for the front bar</span></div><div class="box-val"><strong>' + fpads + '</strong></div></div>';

      installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/front_baseclip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Front Clip Number</strong><span class="caption">Number on the clips required for the front bar</span></div><div class="box-val"><strong>' + fclamps + '</strong></div></div></div>';

      installation += '<div class="right"><div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/front_productbox_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Rear Product</strong><span class="caption">Name of BaseClip product required for rear bar</span></div><div class="box-val"><strong>' + rclip + '</strong></div></div>';        

      installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/rear_basepadicon.png"></div>';
      installation += '<div class="box-desc"><strong>Rear Pad</strong><span class="caption">Number on the pads required for the rear bar</span></div><div class="box-val"><strong>' + rpads + '</strong></div></div>';


      installation += '<div class="box-container"><div class="box-logo"><img src="http://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/rear_baseclip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Rear Pad</strong><span class="caption">Number on the pads required for the rear bar</span></div><div class="box-val"><strong>' + rclamps + '</strong></div></div></div>';

        installation += '<div class="diagram"></div></div>';
    }
    installation += '</div>';
    return installation;
}
function GetSystemHtml(detailPage, fitId, fitTypeId, roofTypeId, fitImage, platformSku, minBarLength, barSizeFront, barSizeRear, loadRating, barCount, components, comment) {
    var systemPrice = 0;
      var mountType = 'Clamp Mount';
      var towerName = towerName + ' Legs Pack of 4';
      var towerSku = '';
      var towerPrice = 0;
      var systemImg = '';
      var systemImg2 = '';
      var fitClass = "";
      var barType = "";
  
        if(fitTypeId == 14) { towerName = 'Truck System'; fitClass = 'truck'; }
        if(fitTypeId == 55) { towerName = 'LockNLoad'; fitClass = 'lnl'; }
        if(fitTypeId == 37 || fitTypeId == 49) { towerName = 'RailBar'; fitClass = 'aero crossbar'; }
        if(fitTypeId == 62) { towerName = 'Aero ThruBar'; fitClass = 'aero crossbar'; }
        if(fitTypeId == 36) { towerName = 'FlushBar Mount'; fitClass = 'aero crossbar'; }
        if(fitTypeId == 38) { towerName = 'BaseLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 32) { towerName = 'BaseLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 33) { towerName = 'TimberLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 43) { towerName = 'TimberLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 34) { towerName = 'SkyLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 39) { towerName = 'SkyLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 42) { towerName = 'SightLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 41) { towerName = 'SightLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 45) { towerName = 'RibCage Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 47) { towerName = 'RuggedLine'; fitClass = 'lnl'; }
        if(fitTypeId == 59) { towerName = 'Mounting Kit'; fitClass = 'trim crossbar'; }
        if(fitTypeId == 942) { towerName = 'SightLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 945) { towerName = 'Yakima SmartFoot'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId >= 63 && fitTypeId <= 68) { 
          towerName = 'Yakima SmartFoot'; 
          fitClass = 'aero crossbar'; 
        }

  if(roofTypeId == 1) {
          mountType = 'Clamp Mount';
      }
      if(roofTypeId == 3) {
          mountType = 'Track Mount';
      }
      if(roofTypeId == 4) {
          mountType = 'Rail Mount';
      }
      if(roofTypeId == 12) {
          mountType = 'Flush Rail Mount';
      }
      if(roofTypeId == 14) {
          mountType = 'Fixed Point Mount';
      }
     if(roofTypeId == 17) {
          mountType = 'Flush Rail/Fixed Point';
      }
      systemImg = towerName.toLowerCase().replace(' mount', '').replace(' ', '-') + '-close.png';

      if(fitTypeId == 942) systemImg = 'trimhd-close.png';
      var isRuggedLine = false;
  
      var platformName = '';
      var towerSku = '';
      var barType = 'JetStream';
      var towerCnt = 0;
      for(i=0;i<components.length;i++) {
          if(components[i].roleId == 1) towerSku = components[i].sku;
          if(components[i].roleId == 6 && components[i].sku != '9812105') { 
            barType = components[i].name.substring(0, components[i].name.indexOf(' Bar'));
            systemImg2 = barType.toLowerCase() + '-2bar.png';
          }
          if(fitTypeId >= 63 && fitTypeId <= 68 && (components[i].roleId == 6 || components[i].roleId == 1)) {
            if(components[i].name.toLowerCase().indexOf('flushbar') >= 0) { platformName = 'Aero FlushBar';  systemImg = 'aero-flushbar-main.png'; systemImg2 = 'aero-flushbar-alt.png'; }
            if(components[i].name.toLowerCase().indexOf('thrubar') >= 0) { platformName = 'Aero ThruBar'; systemImg = 'aero-thrubar-main.png'; systemImg2 = 'aero-thrubar-alt.png'; }
            if(components[i].name.toLowerCase().indexOf('railbar') >= 0) { platformName = 'Aero RailBar';  systemImg = 'aero-railbar-main.png';systemImg2 = 'aero-railbar-alt.png'; }
          }
          if(components[i].sku == '9813044') {towerName = 'SIGHTLINE MOUNT'; systemImg = 'sightline-close.png';   }
          if(components[i].sku == '9813004') {towerName = 'BASELINE MOUNT'; systemImg = 'baseline-close.png';  }
          if(components[i].sku == '9813064') {towerName = 'TIMBERLINE MOUNT'; systemImg = 'timberline-close.png';  }
          if(components[i].sku == '9813024' || components[i].sku == '9813022') {towerName = 'SKYLINE MOUNT';  systemImg = 'skyline-close.png'; }
          if(components[i].sku == '9812105') {towerName = 'Yakima SmartFoot'; fitClass = 'trim crossbar'; systemImg = 'hdlegkit-close.png';  }
          if(components[i].sku == '8000350') {towerName = 'Gutter Mount'; systemImg = 'lnl-guttermount.png';  }
          if(components[i].sku == '8000351') {towerName = 'Gutter Mount'; systemImg = 'guttermount-close.png';  }
          if(components[i].sku == '9812179') { systemImg = 'ruggedline7-close.png';  }
          if(components[i].sku == '8000143' || components[i].sku == '8000144') { systemImg = 'tracklegsmk1-lnl-close.png'; mountType = 'Track Mount';  }
          if(components[i].sku == '9800304' || components[i].sku == '9800306' || components[i].sku == '8000199') { systemImg = 'tracklegsmk1-trimhd-close.png';  mountType = 'Track Mount';   }
          if(components[i].sku == '8001160') { systemImg = 'bedrock-close.png'; towerName = 'BEDROCK LEGS'; }
          if(components[i].sku == '8001152') { systemImg = 'outpost-close.png'; towerName = 'OUTPOST LEGS'; }
          if(components[i].sku == '8001151') { systemImg = 'overhaul-close.png'; towerName = 'OVERHAUL LEGS'; }
        

        if(components[i].name != null) {
            if(components[i].name.indexOf('HD Bar') >= 0 && components[i].sku.indexOf('800115') >= 0) { barType = 'HD';    }     
          if(components[i].name.indexOf('JetStream') >= 0) { barType = 'JetStream'; }     
          if(components[i].name.indexOf('RuggedLine') >= 0) { isRuggedLine = true;  mountType = 'Track Mount'; systemImg = 'ruggedline7-close.png';  }     
        } 
        if(components[i].roleId == 1 || components[i].roleId == 2 || components[i].roleId == 15) towerCnt = towerCnt + components[i].quantity;
        if(components[i].roleId == 6 && components[i].name.toLowerCase().indexOf('platform') >= 0) {
            
            if(systemImg.indexOf('skyline-close') >= 0)
                systemImg = 'lnl-skyline.png'; 
            else if(systemImg.indexOf('timberline-close') >= 0)
                systemImg = 'lnl-timberline.png'; 
            else if(systemImg.indexOf('line-close') > 0 && systemImg.indexOf('ruggedline') < 0)
                systemImg = 'lnl-streamline.png';
            systemImg2 = 'lnl-' + components[i].sku.substring(4, 7) + '.png'; 
        }
     }
     if(systemImg2.indexOf('trimhd') >= 0 && systemImg.indexOf('line-close') >= 0)
        systemImg = systemImg.replace('line-close', 'line-trimhd-close');
     if(towerCnt > 2) barCount = towerCnt;
    if(platformName.length == 0)
      platformName = barType + ' CROSSBAR WITH ' + towerName.replace(' (Towers Only)', '');
  
    jQuery("#page-title").html(towerName);
     //if(fitImage != null && fitImage.length > 0)
     //   systemImg = fitImage;

      if(fitTypeId == 55 || fitTypeId == 47)  {
        platformName = 'LockNLoad Platform';
        if(isRuggedLine) platformName += ' + RUGGEDLINE®';
      }
      if(fitTypeId == 36) { platformName = 'Aero FlushBar'; }
      if(fitTypeId == 62) { platformName = 'Aero ThruBar'; }
      if(fitTypeId == 49) { platformName = 'Aero RailBar'; }
      if(fitTypeId == 46) {  system = '';   }
        

      var system = '<div class="row ' + fitClass + '"><div class="col-sm-6 col-lg-4 image"><img src="https://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/' + systemImg + '">';
      if(systemImg.indexOf('-main') > 0 && systemImg2 != '') {
        systemImg2 = systemImg.replace('-main', '-alt');
      }
      system += '<img src="https://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/' + systemImg2 + '">';
      system += '</div>';
      system += '<div class="details"><h2>' + platformName + '</h2><h5 class="mb-4 mb-lg-5">' + localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name') + '</h5>';
  
  
      //TRUCKBED
      if(fitTypeId == 14) { 
          
          mountType = 'TruckBed Mount';
          towerSku = towerSku;
          towerPrice = towerPrice;
          towerName = towerName.replace('(Towers Only)', '');
          systemPrice += towerPrice;
      }
      //BASELINE
      if(fitTypeId == 32 || fitTypeId == 38) { 
         
          towerSku = fitTypeId == 32 ? '9813004' : '9813014';
      }
      //SKYLINE
      if(fitTypeId == 34 || fitTypeId == 39) { 
         
          mountType = 'Rail Mount';
          towerSku = fitTypeId == 34 ? '9813024' : '9813034';
        
      }
      
      
    console.log('components', components);
    var systemWeight = 0;
      for(i=0;i<components.length;i++) {
       
        if(components[i].roleId == 7) {
          // Ignore Windshields
        }
        else {
          if(components[i].name.indexOf('TrimHD') >= 0 && components[i].quantity == 1) components[i].quantity = towerCnt;
          var price = components[i].price * components[i].quantity + '.00';
          if(components[i].price % 1 > 0) 
            price = components[i].price + '0';
         system += '<dl><dt><span class="bar-label">+ ' + components[i].name + ' x ' + components[i].quantity;

         system += '</span><br>';
         system += '<span class="bar-sku bar-sku-highlight"><small>SKU: ' + components[i].sku + '</small></span>';
         system += getAltBar(components[i].sku);
        
        system += '</dt>';
         system += '<dd class="price-col">$' + price + '</dd></dl>';
         systemPrice += components[i].price * components[i].quantity;
         systemWeight += (components[i].weight * components[i].quantity) * 0.453592;
       }
      }
  
      
  if(comment != null && comment.indexOf('roof gutter') >= 0 )
          mountType = 'Gutter Mount';

    var findDealer = 'Find a Dealer';
    var mountTypeLabel = 'Mount Type';
    var ratingLabel = 'Product Load Rating';
    var warning = 'Please refer to the vehicle manufacturer specifications for max load capacity of vehicle. The lowest load rating applies. Reductions may apply off road. <a href="/pages/roof-rack-load-ratings-explained" target="_blank" style="color: #ab2328;">Learn more.</a>';
    var comments = 'Comments';
    var learnMore = 'Learn More';
    var barSystem = 'Bar System';
  
   
      system += '<dl class="half"><dt>' + mountTypeLabel + ':</dt><dd>' + mountType + '</dd></dl>';
      system += '<dl class="half"><dt>' + ratingLabel + ': </dt><dd>' + loadRating + ' kg</dd></dl>';
      if(systemWeight > 0)
        system += '<dl class="half"><dt>Total Product Weight: </dt><dd>' + systemWeight.toFixed(2) + ' kg</dd></dl>';
      system += '<dl style="font-size: 13px; font-weight: 200;">' + warning + '</dl>';
      system += '<dl class="half"><dt>' + comments + ':</dt></dl><dl style="font-size: 13px; font-weight: 200;"><p id="fitComments">' + comment +'</p>';
      if(barCount == 1 || barCount > 2) system += '<p>Note: ' + barCount + ' ' + barSystem + '</p>';
      system += '</dl>';

        if(detailPage) {
          system += '<a href="/pages/dealer-locator" class="find-dealer btn">' + findDealer + '</a></div>';
        }
      system += '</div>';
      
      var priceText = systemPrice + '.00';
      if(systemPrice % 1 > 0) 
        priceText = systemPrice + '0';
      system += '<div class="more-info"><div class="price-col price">$' + priceText + '</div><div class="font-size-sm">(RRP includes GST and excludes any applicable third-party freight or installation fees)</div>';
        if(!detailPage) {
          
          system += '<a href="/pages/fit-detail?fitId=' + fitId + '" class="btn learn-more">' + learnMore + '</a><a href="/pages/dealer-locator" class="find-dealer btn">' + findDealer + '</a></div></div>';
        }
      

     return system;
}
function getAltBar(sku) {
    var isku = parseInt(sku);
    var altSku = 0;
    if(isku >= 9813700 && isku <= 9813706) altSku = isku + 7;
    if(isku >= 9813500 && isku <= 9813504) altSku = isku + 5;
    if(isku >= 8050227 && isku <= 8050230) altSku = isku - 40;
    if(isku >= 9813500 && isku <= 9813504) altSku = isku + 5;
    if(isku >= 8050217 && isku <= 8050226) altSku = isku - 40;
    if(isku >= 8050238 && isku <= 8050246) altSku = isku - 37;

    //Flushbar 
    if(isku == 8050232) altSku = 8050191;
    if(isku == 8050233) altSku = 8050193;
    if(isku == 8050234) altSku = 8050194;
    if(isku == 8050235) altSku = 8050196;
    if(isku == 8050236) altSku = 8050197;
    if(isku == 8050237) altSku = 8050198;
    if(isku == 8050238) altSku = 8050199;

    if(altSku > 0)
        return '<br><span class="bar-sku bar-sku-highlight"><small>Available in silver (SKU: ' + altSku.toString() + ')</small></span>';
    else 
        return '';
}
function addFilters() {
   var totalCnt = jQuery('#rack-systems .row').length;
   var lnlCnt = jQuery('#rack-systems .row.lnl').length;
   var truckCnt = jQuery('#rack-systems .row.truck').length;
   var crossbarCnt = jQuery('#rack-systems .row.crossbar').length;
   var jsCnt = jQuery('#rack-systems .row.jetstream').length;
   var trimCnt = jQuery('#rack-systems .row.trim').length;
   var aeroCnt = jQuery('#rack-systems .row.aero').length;
  var filter = '';

  var carryWhere = 'Choose your preferred carrying solution';
    var platformLabel = 'Platform';
    var platformDesc = 'Super tough and super strong.  Designed from the ground up for the ultimate 4x4, touring and commercial solution.';
    var crossbarLabel = 'Crossbars';
    var crossbarDesc = 'Secure your load with a set of crossbars from our extensive range.';
    var truckbedLabel = 'Ute Bed';
    var truckbedDesc = 'Carry your gear in the bed of your truck';
    var jetstreamDesc = 'Exceptionally aerodynamic, incredibly strong, lightweight and quiet on the move. Part of the StreamLine range - Yakima\'s newest and best ever roof rack system.';
    var trimDesc = 'Designed for heavier loads, TrimHD crossbars are ideal for 4x4 and commercial setups. Great for vans, utes, trucks and SUVs.';
    var aeroDesc = 'Our classic and original aerodynamic crossbars. Engineered to deliver superior performance with the least possible wind noise, drag, and vibration.';
  
  
  if((lnlCnt > 0 && totalCnt > lnlCnt) || (truckCnt > 0 && totalCnt > truckCnt)) {
    filter = '<div class="fit-placement"><h1>' + carryWhere + '</h1>';
    if(lnlCnt > 0)
      filter += '<div class="fmc-filter half lnl" onclick="applyFilter(\'lnl\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-platform.jpg"><h3>' + platformLabel + '</h3><p>' + platformDesc + '</p></div>';
    filter += '<div class="fmc-filter half crossbar" onclick="applyFilter(\'crossbar\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-roofracks.jpg"><h3>' + crossbarLabel + '</h3><p>' + crossbarDesc + '</p></div>';
    if(truckCnt > 0)
        filter += '<div class="fmc-filter half truck" onclick="applyFilter(\'truck\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-truckbed.jpg"><h3>' + truckbedLabel + '</h3><p>' + truckbedDesc + '</p></div>';
    filter += '</div>';
    jQuery('#fit-filters').html(filter);
    jQuery('#rack-systems .row').hide();
  }
  if(crossbarCnt > 0 && ((jsCnt > 0 && jsCnt < crossbarCnt) || (trimCnt > 0 && trimCnt < crossbarCnt) || (aeroCnt > 0 && aeroCnt < crossbarCnt))) {
    filter += '<div class="fit-crossbars' + ((lnlCnt > 0 && totalCnt > lnlCnt) ? ' hide' : '') + '"><h1>' + crossbarLabel + '</h1>';
    if(jsCnt > 0)
      filter += '<div class="fmc-filter third jetstream" onclick="applyFilter(\'jetstream\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-jetstream.jpg"><h3>JetStream</h3><p>' + jetstreamDesc + '</p></div>';
    if(trimCnt > 0)
      filter += '<div class="fmc-filter third trim" onclick="applyFilter(\'trim\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-trimhd.jpg"><h3>TrimHD</h3><p>' + trimDesc + '</p></div>';
    if(aeroCnt > 0)
      filter += '<div class="fmc-filter third aero" onclick="applyFilter(\'aero\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-aero.jpg"><h3>Aero</h3><p>' + aeroDesc + '</p></div>';
    filter += '</div>'
    
    jQuery('#fit-filters').html(filter);
    jQuery('#rack-systems .row').hide();
  }
  
  if(filter.length == 0)
    jQuery('#fit-filters').hide();
  
}
function applyFilter(cls) {
  jQuery('#rack-systems .row').hide();
  jQuery('#rack-systems .row.' + cls).show();
  
  
  
  if(cls == 'lnl' || cls == 'crossbar' || cls == 'truck') {
    if(cls == 'lnl' || cls == 'truck') jQuery('#fit-filters .fit-crossbars').addClass('hide');
    jQuery('#fit-filters .fit-placement').addClass('short');
    jQuery('#fit-filters .fit-placement .fmc-filter.selected').removeClass('selected');
    jQuery('#fit-filters .fit-placement .fmc-filter.' + cls).addClass('selected');
  }
  else {
    jQuery('#fit-filters .fit-crossbars').addClass('short');
    jQuery('#fit-filters .fit-crossbars .fmc-filter.selected').removeClass('selected');
    jQuery('#fit-filters .fit-crossbars .fmc-filter.' + cls).addClass('selected');
  }
  if(cls == 'crossbar') {
    jQuery('#fit-filters .fit-crossbars.hide').removeClass('hide');
  }
  else {
  }
  
}
function windshieldPage() {
    var fitId = localStorage.getItem('fitId');
    if (fitId && fitId.length > 0) {
        var url = yakimaApiUrl + '/component/GetComponents/US/' + fitId + '/true';

        console.log(url);
        jQuery.get(url, function (data) {
            console.log(data);

            jQuery.each(data, function (i, e) {
                var psku = e.sku;
                if (psku.indexOf('800501') == 0) {
                    jQuery('#product-options-wrapper .cs-options li.cs-selected').removeClass('cs-selected');
                    jQuery('#product-options-wrapper .cs-options li').each(function () {
                        var size = jQuery(this).find('span').first().text();
                        if (e.Name.indexOf(size) >= 0) {
                            jQuery(this).addClass('cs-selected').click();
                            jQuery('#product-options-wrapper .cs-select').removeClass('cs-active');
                        }
                    });
                }
            });
        });
    }
}

function cartPopup() {
    var fitId = localStorage.getItem('fitId');

    jQuery('.cart-items .cart-item').each(function () {
        var cartItem = this;
      var sku = jQuery(this).find('.list-view-item__sku p').first().text().replace('SKU: # ', '');

        var url = yakimaApiUrl + '/fitnote/GetFitNotes/' + fitId + '/' + sku;
        console.log(url);
        jQuery.get(url, function (data) {
            jQuery.each(data, function (i, e) {
                if(e.sKUFilter.indexOf('+') <= 0 && e.note != null) //Ignore the combined SKU filters, like the Roundbar warnings
                    jQuery(cartItem).find('.list-view-item__sku').append('<p style="color: #811a1e; clear: both;">* ' + e.note + '</p>');
            });
        });
        

    });
  
  
}
function callAjax(url, failCnt) {
    console.log(url);
    new Ajax.Request(url, {
        method: 'post',
        onFailure: function (response) {
            failCnt++;
            if (failCnt > 5)
                alert('Ajax call failed: ' + url);
            else
                callAjax(url, failCnt);
        }
    });
}
